import {
	ifAuthenticated,
	ifNotAuthenticated,
	ifAuthenticatedOnline,
	AppTabs,
	Edit,
	Create,
	Index
} from '@/router/index'

import Customer from '@/components/customer/Customer'

export const customers = [
	{
		path: '/customers',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/customers/',
					text: 'Clienti'
				}
			]
		},
		children: [
			{
				path: '/customers/',
				beforeEnter: ifAuthenticatedOnline,
				component: Index,
				props: {
					modelDef: 'customers',
					'action-icon': 'people',
					title: 'Clienti'
				}
			}
		]
	},
	{
		path: '/customers/create',
		name: 'customers-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: route => ({
			modelDef: 'customers',
			redirect: route.params.redirect
		})
	},
	{
		path: '/customers/:id/edit',
		name: 'customers-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: route => ({
			modelDef: 'customers',
			id: parseInt(route.params.id),
			redirect: { modelDef: 'customers', id: parseInt(route.params.id) }
		})
	},
	{
		path: '/customers/:id',
		name: 'customers',
		beforeEnter: ifAuthenticatedOnline,
		component: Customer,
		props: route => ({
			id: parseInt(route.params.id)
		})
	}
]
